<template>
  <div class="room-selection-page">
    <div class="room-header" @click="$router.back()">
      <img src="/static/image/new/room/room-arrow2.png" class="back-arrow" alt="">
      <span>{{ $t('大厅选择') }}</span>
    </div>

    <img src="/static/image/new/room/logo-title-img.png" class="room-logo" alt="MI28">

    <h1>{{ $t('选择房间') }}</h1>

    <div class="room-list">
      <div
        v-for="item in roomList"
        :key="item.type + item.room"
        :class="['room-card', item.theme]"
        @click="selectRoom(item)"
      >
        <img :src="item.icon" class="room-icon" alt="">
        <div class="room-copy">
          <div class="room-title-line">
            <div class="room-name">{{ item.name }}</div>
            <div class="room-tag">{{ $t(item.tagKey) }}</div>
          </div>
          <div class="room-odds">
            <span>{{ $t('赔率') }}：</span>
            <strong>{{ item.odds }}</strong>
          </div>
        </div>
        <img src="/static/image/new/room/room-arrow.png" class="room-arrow" alt="">
      </div>
    </div>

    <div class="room-rules">
      <div class="rules-title">
        <img src="/static/image/new/room/room-tips-icon.png" alt="">
        <span>{{ $t('房间规则') }}</span>
      </div>
      <div class="rules-content">
        <div v-for="ruleKey in ruleKeys" :key="ruleKey">{{ $t(ruleKey) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
const ROOM_LIST = {
  jld28: [
    {
      nameKey: 'MI28-VIP1',
      room: 'one',
      type: 'jld28',
      icon: '/static/image/new/room/room-icon1.png',
      tagKey: '新手推荐',
      odds: '1.8',
      theme: 'room-card-gold'
    },
    {
      nameKey: 'MI28-VIP2',
      room: 'two',
      type: 'jld28',
      icon: '/static/image/new/room/room-icon2.png',
      tagKey: '最热门',
      odds: '2',
      theme: 'room-card-purple'
    },
    {
      nameKey: 'MI28-VIP3',
      room: 'three',
      type: 'jld28',
      icon: '/static/image/new/room/room-icon3.png',
      tagKey: 'VIP专属',
      odds: '2.2',
      theme: 'room-card-yellow'
    }
  ],
  jld28_5: [
    {
      nameKey: 'MI28-VIP1',
      room: 'one',
      type: 'jld28_5',
      icon: '/static/image/new/room/room-icon1.png',
      tagKey: '新手推荐',
      odds: '1.8',
      theme: 'room-card-gold'
    },
    {
      nameKey: 'MI28-VIP2',
      room: 'two',
      type: 'jld28_5',
      icon: '/static/image/new/room/room-icon2.png',
      tagKey: '最热门',
      odds: '2',
      theme: 'room-card-purple'
    },
    {
      nameKey: 'MI28-VIP3',
      room: 'three',
      type: 'jld28_5',
      icon: '/static/image/new/room/room-icon3.png',
      tagKey: 'VIP专属',
      odds: '2.2',
      theme: 'room-card-yellow'
    }
  ]
}

const RULE_KEYS = [
  '房间规则1',
  '房间规则2',
  '房间规则3'
]

export default {
  name: 'game-room-selection',
  data() {
    return {
      gameVideo: 'jld28',
      ruleKeys: RULE_KEYS
    }
  },
  computed: {
    roomList() {
      return this.getRoomList(this.gameVideo)
    }
  },
  created() {
    this.gameVideo = this.normalizeGameVideo(this.$route.query.game_video)
  },
  methods: {
    normalizeGameVideo(gameVideo) {
      return gameVideo === 'jld28_5' ? 'jld28_5' : 'jld28'
    },
    getRoomList(gameVideo) {
      const source = ROOM_LIST[this.normalizeGameVideo(gameVideo)]
      return source.map(item => ({
        ...item,
        // name: this.$t(item.nameKey)
        name: item.nameKey
      }))
    },
    selectRoom(item) {
      this.$router.push({
        path: '/game-room',
        query: {
          game_video: item.type,
          room: item.room
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.room-selection-page {
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  padding: 0 .4rem 1rem;
  overflow-x: hidden;
  color: #fff;
  font-family: PingFang SC, sans-serif;
  background-color: #000;
  background-image: url('/static/image/new/lang/lang-bg.png');
  background-position: center;
  background-size: 100% 100%;

  .room-header {
    display: flex;
    align-items: center;
    height: .45rem;
    padding-top: 0.72rem;
    color: #fff;
    font-size: .4rem;
    font-weight: bold;
    line-height: .45rem;
    white-space: nowrap;
    cursor: pointer;
  }

  .back-arrow {
    width: .32rem;
    height: .22rem;
    margin-right: .12rem;
  }

  .room-logo {
    display: block;
    width: 2.41rem;
    height: auto;
    margin: 0 auto;
  }

  h1 {
    margin: .02rem 0 .22rem;
    color: #fff;
    font-size: .41rem;
    font-weight: 600;
    line-height: .54rem;
  }

  .room-card {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    height: 2.05rem;
    margin-bottom: .25rem;
    padding: .27rem .3rem;
    border-radius: .2rem;
    background: #090809;
    cursor: pointer;
    border: 0.5px solid transparent;
    &.room-card-gold {
      background:
        linear-gradient(#090809, #090809) padding-box,
        linear-gradient(
          180deg,
          #D8AD71 0%,
          #A54B00 100%
        ) border-box;
    }

    &.room-card-purple {
      background:
        linear-gradient(#090809, #090809) padding-box,
        linear-gradient(
          180deg,
          #776477 0%,
          #794279 100%
        ) border-box;
    }

    &.room-card-yellow {
      background:
        linear-gradient(#090809, #090809) padding-box,
        linear-gradient(
          180deg,
          #A78E5F 0%,
          #5F4411 100%
        ) border-box;
    }
  }

  .room-icon {
    width: 1.35rem;
    height: 1.35rem;
    margin-right: .33rem;
  }

  .room-copy {
    flex: 1;
    min-width: 0;
  }

  .room-title-line {
    display: flex;
    align-items: center;
    min-width: 0;
    white-space: nowrap;
  }

  .room-name {
    overflow: hidden;
    color: #fff;
    font-size: .4rem;
    line-height: .48rem;
    text-overflow: ellipsis;
  }

  .room-tag {
    flex: 0 0 auto;
    margin-left: .2rem;
    padding: .07rem .17rem;
    border: 1px solid;
    border-radius: .08rem;
    font-size: .25rem;
    line-height: .27rem;
  }

  .room-card-gold .room-tag {
    border-color: #6e3e06;
    color: #c77d1c;
  }

  .room-card-purple .room-tag {
    border-color: #66416c;
    color: #b68ac1;
  }

  .room-card-yellow .room-tag {
    border-color: #615300;
    color: #d7bc00;
  }

  .room-odds {
    margin-top: .15rem;
    color: #999;
    font-size: .32rem;
    line-height: .42rem;

    strong {
      margin-left: .08rem;
      color: #d88d31;
      font-size: .37rem;
      font-weight: 400;
    }
  }

  .room-arrow {
    flex: 0 0 .28rem;
    width: .28rem;
    height: auto;
    margin-left: .16rem;
  }

  .room-rules {
    box-sizing: border-box;
    width: 100%;
    padding: .3rem;
    border: 1px solid #4d3d2d;
    border-radius: .2rem;
    background: rgba(7, 7, 7, .95);
  }

  .rules-title {
    display: flex;
    align-items: center;
    color: #fff;
    font-size: .4rem;
    line-height: .46rem;
    white-space: nowrap;

    img {
      width: .51rem;
      margin-right: .15rem;
    }
  }

  .rules-content {
    margin-top: .25rem;
    color: #999;
    font-size: .32rem;
    line-height: .4rem;
    >div {
      margin-bottom: .1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/room-selection.vue